import SideBarInformation from './SideBarInformation'

export default SideBarInformation
